import {FormDefinition} from "lib/forms";
import {ProprietarioObject} from "models/Proprietario";
import {startsWith, slice} from "lodash";

export const MAX_RESULTS = 30;

export const getFormDefProprietario = (): FormDefinition => {
  return {
    nome: {name: 'nome', label: 'Nome completo', type: "string", required: true},
    telefone: {name: 'telefone', label: 'Telefone', type: "telefone", required: true},
    pessoa_tipo: {name: 'pessoa_tipo', label: 'Tipo de cadastro', type: "select", required: false},
    cidade: {name: 'cidade', label: 'Cidade', type: "searchInput", required: false},
    estado: {name: 'estado', label: 'Estado', type: "searchInput", required: false},
  }
};

export const filterProprietariosByNome = (collection: ProprietarioObject[],
                                          nome: string): { found: ProprietarioObject[], total: number } => {
  const foundMain: ProprietarioObject[] = [];
  const foundPri: ProprietarioObject[] = [];
  const foundSec: ProprietarioObject[] = [];
  const _nome = nome.toLowerCase().replace(/\s+/g, ' ')
    .trim().normalize("NFD").replace(/\p{Diacritic}/gu, "");
  const _nomePartes = _nome.split(' ');
  const _nomePartesLen = _nomePartes.length;

  // 1: match todas as partes
  for (const p of collection) {
    const _nome2 = p.nome.toLowerCase().replace(/\s+/g, ' ')
      .trim().normalize("NFD").replace(/\p{Diacritic}/gu, "");
    const _nome2Partes = _nome2.split(' ');

    let matchs = 0;
    let iParte = 0;
    for (let i = 0; i < _nomePartesLen; i++) {
      const np = _nomePartes[i];
      if (np.length <= 3 && i !== 0 && matchs === 0)
        continue;

      for (let j = iParte; j < _nome2Partes.length; j++) {
        const np2 = _nome2Partes[j];
        if ((_nomePartesLen === 1 && np2 === np) || (_nomePartesLen > 1 && startsWith(np2, np))) {
          matchs++;
          iParte = j + 1;
          break;
        }

        // se apenas uma parte, e não encontrou, sai do loop
        // if (_nomePartesLen === 1)
        //   break;
      }
    }

    if (matchs === _nomePartesLen) {
      foundMain.push(p);
    } else if (_nomePartesLen > 2 && matchs === _nomePartesLen - 1) {
      foundPri.push(p);
    } else if (_nomePartesLen >= 2 && matchs > 2) {
      foundSec.push(p);
    }
  }

  // sort foundMain by nome.length
  foundMain.sort((a, b) => {
    const aLen = a.nome.split(' ').length;
    const bLen = b.nome.split(' ').length;
    if (aLen > bLen) return 1;
    if (aLen < bLen) return -1;
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
    return 0;
  });

  // sort foundPri by nome.length
  foundPri.sort((a, b) => {
    const aLen = a.nome.split(' ').length;
    const bLen = b.nome.split(' ').length;
    if (aLen > bLen) return 1;
    if (aLen < bLen) return -1;
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
    return 0;
  });

  // sort foundSec by nome.length
  foundSec.sort((a, b) => {
    const aLen = a.nome.split(' ').length;
    const bLen = b.nome.split(' ').length;
    if (aLen > bLen) return 1;
    if (aLen < bLen) return -1;
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
    return 0;
  });

  const mainLen = foundMain.length;
  const priLen = foundPri.length;
  const secLen = foundSec.length;
  const totalLen = mainLen + priLen + secLen;
  let res: ProprietarioObject[] = [];

  if (totalLen > MAX_RESULTS) {
    let saldo = MAX_RESULTS;
    if (mainLen > 0) {
      res.push(...slice(foundMain, 0, saldo));
      saldo -= mainLen;
    }
    if (saldo > 0 && priLen > 0) {
      res.push(...slice(foundPri, 0, saldo));
      saldo -= priLen;
    }
    if (saldo > 0 && secLen > 0) {
      res.push(...slice(foundSec, 0, saldo));
    }
  } else if (totalLen > 0 && (mainLen > 0 || priLen > 0)) {
    res = [...foundMain, ...foundPri];
  } else {
    res = [...foundMain, ...foundPri, ...foundSec];
  }

  // console.log(`foundMain: ${nome}`, foundMain);
  // console.log(`foundPri: ${nome}`, foundPri);
  return {found: res, total: totalLen};
}


export const filterProprietariosByTel = (collection: ProprietarioObject[], telefone: string):
  { found: ProprietarioObject[] } => {
  const _telefone = telefone.replace(/\D/g, '');
  const found: ProprietarioObject[] = [];

  for (const p of collection) {
    if (_telefone) {
      if (p._telefone !== _telefone)
        continue;

      found.push(p);
      break;
    }
  }
  // console.log('filterProprietariosByTel', found);

  if (found.length > 1)
    throw Error('filterProprietariosByTel: found.length > 1');

  return {found};
}


export interface PendingProprietario {
  mode: 'new' | 'use';
  instance: ProprietarioObject;
}